import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@mui/styles'
import {Spacing, Colors} from '../../assets/styles'
import LoadingStateIconAndMessage from '../LoadingStateIconAndMessage'
import MessageBox from '../MessageBox'
import RXRIcon from '../RXRIcon'
import VideoPlayerOverlay from '../VideoPlayerOverlay'
import {formatResidentLine} from './exitSurveyVideoData'

/**
 *
 * @param {Object} props
 * @param {?import('./exitSurveyVideoData').VideoResponse} props.response
 * @param {function} props.onClose
 */
function ExitSurveyVideoPlayerModal({response, onClose}) {
  const classes = useStyles()
  const videoUrl = response?.video?.url
  const [isVideoReady, setIsVideoReady] = useState(false)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    setIsVideoReady(false)
    setHasError(false)
  }, [videoUrl])

  if (!response) {
    return null
  }

  const title = `Video response - ${formatResidentLine(response)}`
  const showLoader = !videoUrl || hasError || !isVideoReady

  return (
    <>
      {videoUrl && !hasError && (
        <div style={{visibility: isVideoReady ? 'visible' : 'hidden'}}>
          <VideoPlayerOverlay
            recording={{url: videoUrl, durationSeconds: response.video.durationSeconds}}
            onClose={onClose}
            title={title}
            preload={'auto'}
            onReady={() => setIsVideoReady(true)}
            onError={() => setHasError(true)}
          />
        </div>
      )}

      {showLoader && (
        <div className={classes.overlay}>
          <div className={classes.closeButton} onClick={onClose} role={'button'} aria-label={'Close video'}>
            <RXRIcon icon={RXRIcon.CLOSE} size={16} color={Colors.rxrWhiteColor} />
            Close
          </div>
          <div className={classes.stage}>
            {hasError ? (
              <MessageBox color={Colors.rxrRedColor} icon={RXRIcon.ERROR}>
                {"We couldn't load this video."}
              </MessageBox>
            ) : (
              <LoadingStateIconAndMessage message={'Loading video'} />
            )}
          </div>
        </div>
      )}
    </>
  )
}

const useStyles = makeStyles({
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 1301,
    backgroundColor: Colors.blackOverlay80,
    display: 'flex',
    flexDirection: 'column',
  },
  closeButton: {
    alignSelf: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    gap: Spacing.spaceExtraSmall,
    margin: Spacing.spaceMedium,
    cursor: 'pointer',
    color: Colors.rxrWhiteColor,
    textDecoration: 'underline',
  },
  stage: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `0 ${Spacing.spaceMedium}px ${Spacing.spaceLarge}px`,
  },
})

ExitSurveyVideoPlayerModal.propTypes = {
  response: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}

export default ExitSurveyVideoPlayerModal
